import { APP_SETTINGS } from '@constants/constants';
import { AppEnvironment, AppTenant } from '@customTypes/app';

export const useSettings = () => {
  const isProd = APP_SETTINGS.environment === AppEnvironment.PROD;
  const isNatera = APP_SETTINGS.tenant === AppTenant.NATERA;

  return {
    isDev: APP_SETTINGS.environment === AppEnvironment.DEV,
    isProd,
    isMyome: APP_SETTINGS.tenant === AppTenant.MYOME,
    isNatera,
    isNateraProd: isNatera && isProd,
  };
};
